import moment from 'moment';

import {
  ChangeCoverageReq,
  Pet,
  PetReq,
  RazaRes,
  SolicitudCambioPetReq,
} from '../../types/Pet/types';
import { dataURLtoFile } from '../../utils/dataURL';
import { apiRequest } from '../Utils/apiClient';
import {
  CHANGE_COVERAGE,
  DOWNLOAD_CARNET,
  DOWNLOAD_POLICY,
  GET_RAZAS,
  PETS,
  SOLICITUD,
  UPDATE_PROFILE_PIC,
} from '../Utils/constants';
import axiosInstance from '../Utils/interceptors';

const postPet = async (body: PetReq): Promise<boolean> => {
  try {
    const { datos_mascota, datos_pago, codigo_vendedor } = body;

    const res = await apiRequest<boolean>('post', PETS, {
      datos_mascota,
      datos_pago,
      ...(codigo_vendedor && { codigo_vendedor }),
    });

    return !!res?.success;
  } catch (error) {
    console.error('❌ [postPet] Error al crear mascota:', error);
    return false;
  }
};

const postSolicitudCambioPet = async (data: SolicitudCambioPetReq): Promise<boolean> => {
  try {
    const res = await apiRequest<boolean>('post', SOLICITUD, data);
    return res.success;
  } catch (error) {
    console.error('Error posting solicitud:', error);
    return false;
  }
};

const changeCoverageToBbva = async (data: ChangeCoverageReq): Promise<boolean> => {
  try {
    console.log('[changeCoverageToBbva] payload', data);
    const res = await apiRequest<object>('post', CHANGE_COVERAGE, data);
    console.log('[changeCoverageToBbva] payload', data);
    return res.success;
  } catch (error) {
    console.error('Error changing coverage:', error);
    return false;
  }
};

const updatePetProfilePic = async ({ pic, petId }: { pic: string; petId: string }) => {
  const timestamp = moment().format('YYYYMMDD-HHmmss');
  const fileName = `profile-pic-pet-${petId}-${timestamp}`;
  const file = dataURLtoFile(pic, fileName);

  const formData = new FormData();
  formData.append('mascotaId', petId);
  formData.append('pic', file);

  const response = await axiosInstance.post(UPDATE_PROFILE_PIC, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
};

const getPets = (): Promise<Pet[] | undefined> =>
  apiRequest<Pet[]>('get', PETS).then((res) => res.data);

const getRazas = (): Promise<RazaRes[] | undefined> =>
  apiRequest<RazaRes[]>('get', GET_RAZAS).then((res) => res.data);

const downloadPoliza = (mascotaId: number | string) =>
  axiosInstance.get<Blob>(DOWNLOAD_POLICY, {
    params: { mascotaId },
    responseType: 'blob',
  });

const downloadCarnet = (mascotaId: number | string) =>
  axiosInstance.get<Blob>(`${DOWNLOAD_CARNET}/${mascotaId}`, {
    responseType: 'blob',
  });

export {
  postPet,
  postSolicitudCambioPet,
  changeCoverageToBbva,
  updatePetProfilePic,
  getPets,
  getRazas,
  downloadPoliza,
  downloadCarnet,
};
